import { Skeleton, VStack, useMediaQuery } from 'native-base';
import React, { memo } from 'react';
import { BorderedCard } from 'fmc-digital-common';
const LoanStatusTrackerSkeleton = ({
  dataTestID
}) => {
  const [isSmallScreen] = useMediaQuery({
    maxWidth: 768
  });
  const skeltonSize = isSmallScreen ? 2 : 4;
  return /*#__PURE__*/React.createElement(BorderedCard, {
    borderRadius: "4",
    borderWidth: "1",
    bgColor: isSmallScreen ? 'none' : 'lightBlue.200',
    px: "4",
    py: isSmallScreen ? '4' : '8',
    testID: dataTestID,
    flex: 2,
    mb: 8,
    overflowX: "auto"
  }, /*#__PURE__*/React.createElement(VStack, {
    space: isSmallScreen ? 1 : 2
  }, Array(skeltonSize).fill(0).map(() => /*#__PURE__*/React.createElement(Skeleton, {
    maxH: "4",
    w: "auto",
    startColor: "lightBlue.400",
    borderRadius: "4"
  }))));
};
export default /*#__PURE__*/memo(LoanStatusTrackerSkeleton);
//# sourceMappingURL=LoanStatusTrackerSkelton.js.map